import day from './themes/day/colors.json';
import night from './themes/night/colors.json';

export { day, night };
